import React, { FC, useEffect, useRef } from "react";
// import Users from "@assets/User.svg";
// import Dashboard from "@assets/Dashboard.svg";
// import Cloud from "@assets/Cloud.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { routeMap } from "@utils/constants";
import classnames from "classnames";
import { get, map } from "lodash";
// import sessionService from "../../services/session.service";
import membersService from "../../services/members.service";
import "./sidebar.scss";
import Icon from "@assets/icon_config";
import { usePopulationInsightStore } from "@stores/populationInsightStore";
import { useMemberListStore } from "@stores/useMemberListStore";
import { usePatientProfileStore } from "@stores/patientProfileStore";
import { useHospitalMappingStore } from "@stores/useHospitalMappingStore";
import { useDashboardStore } from "@stores/dashboardStore";
import { useGlobalInformationStore } from "@stores/global_informationStore";
import { useConfigStore } from "@stores/useConfigStore";
import { useHighCostPatientStore } from "@stores/highCostPatientStore";
import { useHighIntensityProgramStore } from "@stores/highIntensityStore";
import { useGenericTableStore } from "@stores/useGenericTableStore";
import { useDataQualityReportStore } from "@stores/dataQualityReport";
import { useMeasuresStore } from "@stores/measuresStore";
import { useChronicBreakdownStore } from "@stores/chronicBreakdownStore";

type TSidebarProps = {};

const Sidebar: FC<TSidebarProps> = () => {
  const fetchConfig = useConfigStore((state) => state.fetchConfig);
  const config = useConfigStore((state) => state.config);
  const loader = useConfigStore((state) => state.loader);
  const setSelectedHospitalListFacility = useGlobalInformationStore((state) => state.setSelectedHospitalListFacility);
  const sideBarOptions = useRef<any>({});
  useEffect(() => {
    if (!config && !loader) {
      fetchConfig();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fetchConfig, config]);

  useEffect(() => {
    sideBarOptions.current = {
      options: get(config, "left_navigation.navigation.optionValues", []),
      noSideBarOptions: get(config, "left_navigation.navigation.optionValues", []).every((a: any) => !a.show),
    };
  }, [config]);

  // const { config } : any = useConfig();
  const navigate = useNavigate();

  const location = useLocation();

  //Fetching latest release notes of the application
  const getReleaseNotes = () => {
    try {
      membersService.getReleaseNotes().subscribe({
        next: (v) => {
          if (v?.data?.status === "OK") {
            // window.open(v.data.data.fileURL);
            fetch(v?.data?.data?.fileURL)
              .then((response) => {
                response.blob().then((blob) => {
                  let url = window.URL.createObjectURL(blob);
                  let doc = document.createElement("a");
                  doc.href = url;
                  doc.download = v?.data?.data?.fileURL?.split("?")?.shift()?.split("/")?.pop();
                  doc.click();
                  window.URL.revokeObjectURL(url);
                });
              })
              .catch((error) => {
                console.log(error.message);
              });
          }
        },
        error: (e) => {
          console.log(e);
        },
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getonClickFunction = (functionName: string) => {
    switch (functionName) {
      case "getReleaseNotes":
        return getReleaseNotes;
      default:
        return () => {};
    }
  };

  const sidebarClassName = classnames("sidebar-bar-container", { "sidebar__no-option": sideBarOptions.current.noSideBarOptions }, { "w-100": loader });

  return (
    <div className={sidebarClassName}>
      {/* Adding height and overflow-y to sidebar div makes top option scrollable ( In Future if Required ) */}
      {!loader ? (
        <div className={`sidebar sticky-align-header`}>
          {map(sideBarOptions.current?.options, (option: any) => {
            if (option.navigation && option.show) {
              const tabClassName = classnames("sidebar-option", {
                active: location.pathname.includes(option.value),
              });
              return (
                <div
                  key={option.value}
                  className={tabClassName}
                  onClick={() => {
                    if (location.pathname !== get(routeMap, option.navigateTo)) {
                      navigate(get(routeMap, option.navigateTo));
                      usePopulationInsightStore.getState().clearStore();
                      usePatientProfileStore.getState().clearStore();
                      useMemberListStore.getState().clearStore();
                      useDashboardStore.getState().clearStore();
                      useHospitalMappingStore.getState().clearStore();
                      useHighCostPatientStore.getState().clearStore();
                      useHighIntensityProgramStore.getState().clearStore();
                      useGenericTableStore.getState().clearStore();
                      useGlobalInformationStore.getState().clearStore();
                      useDataQualityReportStore.getState().clearStore();
                      setSelectedHospitalListFacility("");
                      useMeasuresStore.getState().clearStore();
                      useChronicBreakdownStore.getState().clearStore();

                    }
                  }}
                >
                  <div className="sidebard--option-icon">
                    <Icon name={option.icon} colorOfBrand={location.pathname.includes(option.value) ? "#EF6D2A" : "#7A869A"} />
                  </div>
                  <span className="sidebard--option-label">{option.name}</span>
                </div>
              );
            } else if (option.show) {
              return (
                <div className="release-notes">
                  <div className="release-notes__separator"></div>
                  <div className="release-notes__container" onClick={getonClickFunction(option.navigateTo)}>
                    <div className="release-notes__container__title">{option.name}</div>
                  </div>
                </div>
              );
            }
          })}
        </div>
      ) : (
        <div className={`sidebar sticky-align-header`}>
          {map(Array.from(Array(4).keys()), (item) => {
            return (
              <div key={item} className={"sidebar-option_preloader"}>
                <div className="sidebard--option-icon sidebard--option-icon_preloader shimmerBG"></div>
                <div className="sidebard--option-label sidebard--option-label_preloader shimmerBG"></div>
              </div>
            );
          })}
          <div className="release-notes release-notes_preloader">
            <div className="release-notes__separator shimmerBG"></div>
            <div className="release-notes__container shimmerBG">
              <div className="release-notes__container__title shimmerBG"></div>
            </div>
          </div>
        </div>
      )}
      {sideBarOptions.current?.noSideBarOptions && !loader && (
        <div>
          No Access <br />
          Available
        </div>
      )}
    </div>
  );
};

export default Sidebar;
